import AmountV2 from "./Wallet/ChinaPayoutV2/steps/Amount";
import SenderV2 from "./Wallet/ChinaPayoutV2/steps/Sender";
import BeneficiaryV2 from "./Wallet/ChinaPayoutV2/steps/Beneficiary";
import PaymentDetailsV2 from "./Wallet/ChinaPayoutV2/steps/PaymentDetails";
import ReviewV2 from "./Wallet/ChinaPayoutV2/steps/ReviewV2";

import Amount from "./Wallet/ChinaPayout/steps/Amount";
import Sender from "./Wallet/ChinaPayout/steps/Sender";
import Beneficiary from "./Wallet/ChinaPayout/steps/Beneficiary";
import PaymentDetails from "./Wallet/ChinaPayout/steps/TransactionDetails";
import Review from "./Wallet/ChinaPayout/steps/Review";
import TransactionStatus from "../../components/transactions/components/TransctionStatus";
import * as InternationalPayoutForAfrica from "./components/Withdrawal/InternationalPayoutForAfrica";
import * as GHSPayoutV2 from "./PayoutV2/ghs/index";
import * as KESPayoutV2 from "./PayoutV2/kes/index";
import * as ZMWPayoutV2 from "./PayoutV2/zmw/index";
import * as ZARPayoutV2 from "./PayoutV2/zar/index";
import * as TZSPayoutV2 from "./PayoutV2/tzs/index";
import * as NGNPayoutV2 from "./PayoutV2/ngn/index";
import * as StableCoinPayoutV2 from "./PayoutV2/stableCoin/index";
import { formatLongString } from "../../utils/formatString";
import React from "react";
import Arrow from "../../assets/icons/arrow-up.svg";
import Copied from "../../assets/icons/copy.svg";

export type PaymentStep = {
  index?: number;
  title: string;
  stepTitle: string;
  description?: string;
  component: React.ComponentType<any>;
};

export const industries = [
  "Accounting and auditing",
  "Activities of holding company",
  "Activities of trust",
  "Advertising agencies",
  "Affiliate Marketing",
  "Affiliate gambling or betting",
  "Air transport",
  "Amusement parks and theme parks",
  "Animal production",
  "Aquaculture",
  "Artistic creation",
  "Asset management",
  "Banks or building societies",
  "Barristers",
  "Beverage serving activities",
  "Biotechnology",
  "Bookkeeping",
  "Books and other literature",
  "Brokerages",
  "Business and employers membership organisation",
  "Buying, selling or renting own real estate",
  "Cash intensive",
  "CBD",
  "Charity",
  "Child day-care",
  "Cleaning activities",
  "Compulsory social security",
  "Computer programming",
  "Construction of buildings",
  "Construction of roads and railways",
  "Construction of utilities",
  "Data processing",
  "Demolition or site preparation",
  "Direct gambling or betting",
  "Educational support activities",
  "Electrical, plumbing or other construction installation activities",
  "E-money",
  "Employment services",
  "Exchanges",
  "Extraction of oil or natural gas",
  "Financial consulting",
  "Fire service",
  "Fishing",
  "Foreign affairs",
  "General public administration",
  "Growing of crops",
  "Hair & beauty services",
  "Higher education",
  "Hospital activities",
  "Hotels or similar",
  "HR consulting",
  "Hunting",
  "Investigation activities",
  "IT consulting",
  "Landscaping activities",
  "Lead generation",
  "Leasing of intellectual property and similar products",
  "Library or archives",
  "Life insurance",
  "Logging",
  "Maintenance and repair of motor vehicles",
  "Manufacture of beverages",
  "Manufacture of chemicals",
  "Manufacture of electrical equipment",
  "Manufacture of food products",
  "Manufacture of furniture",
  "Manufacture of metal or metal products",
  "Manufacture of refined products relating to petroleum",
  "Manufacture of rubber or plastic",
  "Manufacture of textiles",
  "Manufacture of tobacco products",
  "Manufacture of vehicles or transport equipment",
  "Manufacture of wood and wood products",
  "Market research",
  "Media representation services",
  "Medical and dental practice activities",
  "Miners",
  "Mining",
  "Money Service Business",
  "Motion picture; video or TV",
  "Natural sciences",
  "Niche or alternative dating",
  "Non-life insurance",
  "NutriScience",
  "Office admin or support activities",
  "Operation of fitness or sporting facilities",
  "Operations consulting",
  "Other",
  "Other accounting",
  "Other advertising",
  "Other agriculture",
  "Other amusement or recreation activities",
  "Other arts",
  "Other construction",
  "Other crypto",
  "Other dating",
  "Other education",
  "Other extraction",
  "Other finance",
  "Other fishing",
  "Other forestry",
  "Other gambling or betting",
  "Other human health activities",
  "Other insurance",
  "Other IT",
  "Other land transport",
  "Other legal",
  "Other manufacture",
  "Other marketing",
  "Other media",
  "Other membership organisations",
  "Other mining",
  "Other personal services",
  "Other pharmaceutical",
  "Other professional services",
  "Other real estate",
  "Other renting or leasing",
  "Other research & development",
  "Other sale",
  "Other security",
  "Other sports activities",
  "Other storage",
  "Other transport",
  "Other utility",
  "Payday loans",
  "Payment institute",
  "Pension funding",
  "Performing arts",
  "Pharmaceutical manufacture",
  "Physical well-being services",
  "Political organisations",
  "Postal or courier",
  "Power",
  "Pre-primary education",
  "Primary education",
  "Private Banking",
  "Private security activities",
  "Professional membership organisations",
  "Public defence",
  "Public justicial activities",
  "Public order and safety",
  "Quarrying",
  "R&D",
  "Racehorse owners",
  "Radio broadcasting",
  "Rail transport",
  "Real estate agencies",
  "Regulation of businesses",
  "Regulation of public services",
  "Religious organisations",
  "Remediation or other waste management services",
  "Renting of motor vehicles",
  "Renting of other machinery, equipment and tangible goods",
  "Renting of personal or household goods",
  "Residential care activities",
  "Restaurants and other food-serving establishments",
  "Risk and damage evaluation",
  "Road transport",
  "Sale of food",
  "Sale of fuel",
  "Sale of goods",
  "Sale of IT or electronics",
  "Sale of machinery",
  "Sale of materials",
  "Sale of motor vehicles",
  "Sale or scrapping of metal",
  "Secondary education",
  "Security systems service activties",
  "Services to the gambling or betting industry",
  "Sewerage",
  "Social media related",
  "Social work activities",
  "Software providers",
  "Software publishing",
  "Solicitors",
  "Sound recording and music",
  "Sports + recreation education",
  "Sports clubs",
  "Strategy consulting",
  "Support activities for mining/quarrying",
  "Support activities for oil/gas extraction",
  "Support activities for transport",
  "Support activities to agriculture",
  "Support services to forestry",
  "Telecommunications activities",
  "Trade unions",
  "Trading",
  "Traditional dating",
  "Transport via pipeline",
  "Travel agency or services",
  "Warehousing and storage",
  "Waste collection",
  "Water transport",
  "Water treatment or supply",
  "Wealth Management",
];

export const companyEnterprise = [
  { value: "ltd", label: "LTD" },
  { value: "partnership", label: "Partnership" },
  { value: "plc", label: "PLC" },
];

export const staticCurrencies = ["kes", "zmw", "zar", "xof", "tzs", "ghs"];

export const accountsCurrencyDetails = {
  zmw: {
    accountNumber: "5615000014466",
    branchCode: "360002",
    bankName: "Ecobank Limited",
    accountType: "360002",
  },
  zar: {
    accountNumber: "1227634846",
    bankName: "Nedbank",
    accountType: "Nedszajj",
  },
  kes: {
    accountNumber: "55010160015196",
    bankName: "UBA",
    accountType: "UNAFKENA",
  },
  xof: {
    accountNumber: "55010160015196",
    bankName: "UBA",
    accountType: "UNAFKENA",
  },
  tzs: {
    accountNumber: "015C847724403",
    bankName: "CRDB Bank",
    accountType: "N/A",
  },
  ghs: {
    accountNumber: "6110113999",
    bankName: "Zenith Bank Ghana",
    accountType: "Head Office",
  },
};

export const TZSPayouts = [
  { value: "TZ-BANK-B2C", label: "Bank Account" },
  { value: "TZ-TIGO-B2C", label: "Momo TIGO" },
  { value: "TZ-AIRTEL-B2C", label: "Momo AIRTEL" },
];

export const CnyStepsData = [
  {
    number: 0,
    title: "Amount",
    stepTitle: "How much are you sending?",
    component: Amount,
  },
  {
    number: 1,
    title: "Sender",
    stepTitle: "Sender details",
    component: Sender,
  },
  {
    number: 2,
    title: "Beneficiary",
    stepTitle: "Beneficiary details",
    component: Beneficiary,
  },
  {
    number: 3,
    title: "Payment details",
    stepTitle: "Payment details",
    description: null,
    component: PaymentDetails,
  },
  {
    number: 4,
    title: "Review",
    stepTitle: "Review the details of your transaction",
    component: Review,
  },
];

export const CnyStepsDataV2 = [
  {
    number: 0,
    title: "Amount",
    stepTitle: "How much are you sending?",
    component: AmountV2,
  },
  {
    number: 1,
    title: "Sender",
    stepTitle: "Sender details",
    component: SenderV2,
  },
  {
    number: 2,
    title: "Beneficiary",
    stepTitle: "Beneficiary details",
    component: BeneficiaryV2,
  },
  {
    number: 3,
    title: "Payment details",
    stepTitle: "Payment details",
    description: null,
    component: PaymentDetailsV2,
  },
  {
    number: 4,
    title: "Review",
    stepTitle: "Review the details of your transaction",
    component: ReviewV2,
  },
];

export const internationalPayoutSteps = [
  {
    number: 0,
    title: "Amount",
    stepTitle: "How much are you sending?",
    component: InternationalPayoutForAfrica.Amount,
  },
  {
    number: 1,
    title: "Beneficiary",
    stepTitle: "Who are you sending to?",
    description: null,
    component: InternationalPayoutForAfrica.Beneficiary,
  },
  {
    number: 2,
    title: "Review",
    component: InternationalPayoutForAfrica.Review,
  },
];

export const cnyTypeOfpaymentMethod = [
  { name: "Union pay", value: "unionpay" },
  { name: "Alipay", value: "alipay" },
  { name: "WeChatPay", value: "wechatpay" },
  { name: "Bank Account (Individual)", value: "bank_account_individual" },
  { name: "Bank Account (Business)", value: "bank_account_business" },
];

export const cnyPaymentPurpose = [
  { name: "Salary", value: "SALARY" },
  { name: "Family support", value: "FAMILY_SUPPORT" },
  { name: "Travel", value: "TRAVEL" },
  { name: "Insurance", value: "INSURANCE" },
  { name: "Investment", value: "INVESTMENT" },
  { name: "Goods purchased", value: "GOODS_PURCHASE" },
  { name: "Service charges", value: "SERVICE_CHARGES" },
  { name: "Patent royalty", value: "PATENT_ROYALTY" },
  { name: "Ecommerce", value: "ECOMMERCE" },
  {name: "others", value: "OTHER"}
];

export const paymentMethodConfigurations = {
  unionpay: {
    serviceCode: "UNIONPAY",
    service: "BANK_CARD",
    fundSource: "CASH",
    transferType: "C2C",
  },
  alipay: {
    serviceCode: "ALIPAY",
    service: "WALLET",
    fundSource: "CASH",
    transferType: "C2C",
  },
  wechatpay: {
    serviceCode: "WECHATPAY",
    service: "WALLET",
    fundSource: "CASH",
    transferType: "C2C",
  },
  bank_account_individual: {
    service: "BANK_ACCOUNT",
    fundSource: "CASH",
    transferType: "C2C",
  },
  bank_account_business: {
    service: "BANK_ACCOUNT",
    fundSource: "CASH",
    transferType: "B2B",
  },
};

export const CNYIDTypes = [
  { label: "National ID card", value: "ID_CARD" },
  {
    label: "Unified Social Credit ID of China registered company",
    value: "UNIFIED_SOCIAL_CREDIT_ID",
  },
  { label: "Passport", value: "PASSPORT" },
  { label: "Business registration cert", value: "BUSINESS_REGISTRATION_CERT" },
  {
    label: "Hong kong macao taiwan permit",
    value: "HONGKONG_MACAO_TAIWAN_PERMIT",
  },
  { label: "Other", value: "OTHER" },
];

export const AttachmentFileType = [
  { label: "Customs declaration", value: "CUSTOMS_DECLARATION" },
  { label: "Commercial documents", value: "COMMERCIAL_DOCUMENTS" },
  { label: "Logistics documents", value: "LOGISTICS_DOCUMENTS" },
];

/* @deprecated */
export const Relationships = [
  { label: "Self", value: "SELF" },
  { label: "Spouse", value: "SPOUSE" },
  { label: "Parents", value: "PARENTS" },
  { label: "Sons and Daughters", value: "SONS_AND_DAUGHTERS" },
  { label: "Brothers and Sisters", value: "BROTHERS_AND_SISTERS" },
  { label: "Grandparents", value: "GRANDPARENTS" },
  { label: "Grandparents-in-Law", value: "GRANDPARENTS_IN_LAW" },
  { label: "Grandchildren", value: "GRANDCHILDREN" },
  { label: "Maternal Grandchildren", value: "MATERNAL_GRANDCHILDREN" },
];

export const WECHAT_RELATIONSHIPS = [
  { label: "Spouse", value: "SPOUSE" },
  { label: "Parent", value: "PARENTS" },
  { label: "Child", value: "SONS_AND_DAUGHTERS" },
  { label: "Other", value: "OTHER" },
];

export const CHINA_PAYOUT_SOURCE_CURRENCIES = ["USD", "NGN"] as const;
export const CHINA_PAYOUT_SOURCE_WALLET_KEY = "chinaPayoutSourceWallet";

export type ChinaPayoutSourceCurrency =
  (typeof CHINA_PAYOUT_SOURCE_CURRENCIES)[number];

export const getChinaPayoutSourceCurrencies = (
  enableNgnSource: boolean,
): readonly ChinaPayoutSourceCurrency[] =>
  enableNgnSource ? CHINA_PAYOUT_SOURCE_CURRENCIES : ["USD"];

/* @deprecated */
export const BENEFICIARY_OPTIONS = [
  { label: "Individual", value: "individual", type: "individual" },
  { label: "Business", value: "company", type: "business" },
];

export const ACCOUNT_ID_TYPES = [
  { label: "Mobile", value: "MOBILE" },
  { label: "Email", value: "EMAIL" },
];

export const WALLET_TRANSACTIONS_TABLE_COLUMNS = [
  {
    title: "Total amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Transaction type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Transaction ID",
    dataIndex: "transId",
    key: "transId",
    render: (text: string) => formatLongString(text, 25) || "N/A",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text: string) => <TransactionStatus text={text} />,
  },
];

export const WALLET_MENU_ITEMS = [
  {
    key: "1",
    label: "Update payment",
    icon: Arrow,
  },
  {
    key: "2",
    label: "Copy reference",
    icon: Copied,
  },
];

export const PAWA_PAY_PAYMENT_METHODS = {
  benin: [
    { label: "MTN", value: "mtn" },
    { label: "Moov", value: "moov" },
  ],
  "burkina-faso": [
    { label: "Orange", value: "orange" },
    { label: "Moov", value: "moov" },
  ],
  "cote_d-ivoire": [
    { label: "MTN", value: "mtn" },
    { label: "Orange", value: "orange" },
    { label: "Wave", value: "wave" },
  ],
  cameroon: [
    { label: "MTN", value: "mtn" },
    { label: "Orange", value: "orange" },
  ],
  "congo-brazzaville": [
    { label: "Airtel", value: "airtel" },
    { label: "MTN", value: "mtn" },
  ],
  gabon: [{ label: "Airtel", value: "airtel" }],
  kenya: [{ label: "Mpesa", value: "mpesa" }],
  malawi: [
    { label: "Airtel", value: "airtel" },
    { label: "TNM", value: "tnm" },
  ],
  senegal: [
    { label: "Free", value: "free" },
    { label: "Orange", value: "orange" },
    { label: "Wave", value: "wave" },
  ],
  "sierra-leone": [{ label: "Orange", value: "orange" }],
  zambia: [
    { label: "Airtel", value: "airtel" },
    { label: "MTN", value: "mtn" },
    { label: "Zamtel", value: "zamtel" },
  ],
  "democratic-republic-of-congo": [
    { label: "Airtel", value: "airtel" },
    { label: "Orange", value: "orange" },
    { label: "Vodacom", value: "vodacom" },
  ],
  rwanda: [
    { label: "MTN", value: "mtn" },
    { label: "Airtel", value: "airtel" },
  ],
  tanzania: [
    { label: "TigoPesa", value: "tigopesa" },
    { label: "Airtel", value: "airtel" },
    { label: "Halotel", value: "halotel" },
    { label: "Vodacom", value: "vodacom" },
  ],
  uganda: [
    { label: "MTN", value: "mtn" },
    { label: "Airtel", value: "airtel" },
  ],
};

export const PAWA_PAY_PAYMENT_OPTIONS_BY_CURRENCY = {
  benin: [
    { label: "MTN Momo", value: "MTN_MOMO_BEN" },
    { label: "Moov", value: "MOOV_BEN" },
  ],
  "burkina-faso": [
    { label: "Orange", value: "ORANGE_BFA" },
    { label: "Moov", value: "MOOV_BFA" },
  ],
  "cote-d-ivoire": [
    { label: "MTN Momo", value: "MTN_MOMO_CIV" },
    { label: "Orange", value: "ORANGE_CIV" },
    { label: "Wave", value: "WAVE_CIV" },
  ],
  cameroon: [
    { label: "MTN Momo", value: "MTN_MOMO_CMR" },
    { label: "Orange", value: "ORANGE_CMR" },
  ],
  "congo-brazzaville": [
    { label: "Airtel", value: "AIRTEL_COG" },
    { label: "MTN Momo", value: "MTN_MOMO_COG" },
  ],
  gabon: [{ label: "Airtel", value: "AIRTEL_GAB" }],
  kenya: [{ label: "Mpesa", value: "MPESA_KEN" }],
  malawi: [
    { label: "TNM", value: "TNM_MWI" },
    { label: "Airtel", value: "AIRTEL_MWI" },
  ],
  senegal: [
    { label: "Free", value: "FREE_SEN" },
    { label: "Orange", value: "ORANGE_SEN" },
    { label: "Wave", value: "WAVE_SEN" },
  ],
  "sierra-leone": [{ label: "Orange", value: "ORANGE_SLE" }],
  zambia: [
    { label: "Zamtel", value: "ZAMTEL_ZMB" },
    { label: "MTN Momo", value: "MTN_MOMO_ZMB" },
    { label: "Airtel", value: "AIRTEL_OAPI_ZMB" },
  ],
  "democratic-republic-of-congo": [
    { label: "Airtel", value: "AIRTEL_COD" },
    { label: "Orange", value: "ORANGE_COD" },
    { label: "Vodacom", value: "VODACOM_COD" },
  ],
  rwanda: [
    { label: "MTN Momo", value: "MTN_MOMO_RWA" },
    { label: "Airtel", value: "AIRTEL_RWA" },
  ],
  tanzania: [
    { label: "TigoPesa", value: "TIGO_TZA" },
    { label: "Halotel", value: "HALOTEL_TZA" },
    { label: "Vodacom", value: "VODACOM_TZA" },
    { label: "Airtel", value: "AIRTEL_TZA" },
  ],
  uganda: [
    { label: "MTN Momo", value: "MTN_MOMO_UGA" },
    { label: "Airtel", value: "AIRTEL_OAPI_UGA" },
  ],
};

export const SUPPORTED_PAWA_PAY_COUNTRIES = [
  {
    currencyCode: "cdf",
    value: "The Republic of Congo",
    slug: "republic-of-congo",
  },
  { currencyCode: "ugx", value: "Uganda", slug: "uganda" },
  { currencyCode: "xof", value: "Senegal", slug: "senegal" },
  { currencyCode: "xof", value: "Ivory Coast", slug: "ivory-coast" },
  { currencyCode: "xof", value: "Côte d'Ivoire", slug: "cote-d-ivoire" },
  { currencyCode: "xaf", value: "Cameroon", slug: "cameroon" },
  { currencyCode: "rwf", value: "Rwanda", slug: "rwanda" },
  { currencyCode: "zmw", value: "Zambia", slug: "zambia" },
  { currencyCode: "xof", value: "Benin", slug: "benin" },
  { currencyCode: "sll", value: "Sierra Leone", slug: "sierra-leone" },
  { currencyCode: "xof", value: "Burkina Faso", slug: "burkina-faso" },
  {
    currencyCode: "cdf",
    value: "Democratic Republic of Congo",
    slug: "democratic-republic-of-congo",
  },
  { currencyCode: "xaf", value: "Gabon", slug: "gabon" },
  { currencyCode: "kes", value: "Kenya", slug: "kenya" },
  { currencyCode: "mwk", value: "Malawi", slug: "malawi" },
  { currencyCode: "tzs", value: "Tanzania", slug: "tanzania" },
];

export const countryToISOCode = {
  senegal: "SN",
  benin: "BJ",
  "burkina-faso": "BF",
  "ivory-coast": "CI",
  "cote-d-ivoire": "CI",
  cameroon: "CM",
  gabon: "GA",
  kenya: "KE",
  malawi: "MW",
  "sierra-leone": "SL",
  zambia: "ZM",
  "republic-of-congo": "CG",
  "democratic-republic-of-congo": "CD",
  rwanda: "RW",
  tanzania: "TZ",
  uganda: "UG",
};

export const countryPhoneCodes = {
  NGN: "+234",
  GHS: "+233",
  KES: "+254",
  USD: "+1",
  TZS: "+255",
  ZMW: "+260",
  ZAR: "+27",
  CNY: "+86",
};

export const walletTopupAccountNarrationMsg = {
  default:
    "You must send your payment with the narration above to complete the top-up. Your funds will reflect in your balance as soon as transfer is confirmed within 24-72 hours.",
  tzs: "Complete your top-up by sending payment with the exact narration above. A 0.7% processing fee applies. Funds will reflect in 24–72 hours after confirmation.",
};

export const paymentStepsByCurrency: Record<string, PaymentStep[]> = {
  ghs: [
    {
      index: 0,
      title: "Amount",
      stepTitle: "How much are you sending?",
      description: null,
      component: GHSPayoutV2.Amount,
    },
    {
      index: 1,
      title: "Beneficiary",
      stepTitle: "Who are you sending to?",
      description: null,
      component: GHSPayoutV2.Beneficiary,
    },
    {
      index: 2,
      title: "Review",
      stepTitle: "Review",
      description: null,
      component: GHSPayoutV2.Review,
    },
  ],

  kes: [
    {
      index: 0,
      title: "Amount",
      stepTitle: "How much do you want to send?",
      description: null,
      component: KESPayoutV2.Amount,
    },
    {
      index: 1,
      title: "Beneficiary",
      stepTitle: "Who are you sending to?",
      description: null,
      component: KESPayoutV2.Beneficiary,
    },
    {
      index: 2,
      title: "Review",
      stepTitle: "Review",
      description: null,
      component: KESPayoutV2.Review,
    },
  ],

  zmw: [
    {
      index: 0,
      title: "Amount",
      stepTitle: "How much do you want to send?",
      description: null,
      component: ZMWPayoutV2.Amount,
    },
    {
      index: 1,
      title: "Beneficiary",
      stepTitle: "Who are you sending to?",
      description: null,
      component: ZMWPayoutV2.Beneficiary,
    },
    {
      index: 2,
      title: "Review",
      stepTitle: "Review",
      description: null,
      component: ZMWPayoutV2.Review,
    },
  ],

  zar: [
    {
      index: 0,
      title: "Amount",
      stepTitle: "How much do you want to send?",
      description: null,
      component: ZARPayoutV2.Amount,
    },
    {
      index: 1,
      title: "Beneficiary",
      stepTitle: "Who are you sending to?",
      description: null,
      component: ZARPayoutV2.Beneficiary,
    },
    {
      index: 2,
      title: "Review",
      stepTitle: "Review",
      description: null,
      component: ZARPayoutV2.Review,
    },
  ],

  tzs: [
    {
      index: 0,
      title: "Amount",
      stepTitle: "How much do you want to send?",
      description: null,
      component: TZSPayoutV2.Amount,
    },
    {
      index: 1,
      title: "Beneficiary",
      stepTitle: "Who are you sending to?",
      description: null,
      component: TZSPayoutV2.Beneficiary,
    },
    {
      index: 2,
      title: "Review",
      stepTitle: "Review",
      description: null,
      component: TZSPayoutV2.Review,
    },
  ],

  ngn: [
    {
      index: 0,
      title: "Amount",
      stepTitle: "How much do you want to send?",
      description: null,
      component: NGNPayoutV2.Amount,
    },
    {
      index: 1,
      title: "Beneficiary",
      stepTitle: "Who are you sending to?",
      description: null,
      component: NGNPayoutV2.Beneficiary,
    },
    {
      index: 2,
      title: "Review",
      stepTitle: "Review",
      description: null,
      component: NGNPayoutV2.Review,
    },
  ],

  usdc: [
    {
      index: 0,
      title: "Amount",
      stepTitle: "Send funds from your USDC wallet",
      description: null,
      component: StableCoinPayoutV2.Amount,
    }, 
    {
      index: 1,
      title:"Review",
      stepTitle: "Review the details of your transaction",
      description: null,
      component: StableCoinPayoutV2.Review,
    }
  ],
  usdt: [
    {
      index: 0,
      title: "Amount",
      stepTitle: "Send funds from your USDT wallet",
      description: null,
      component: StableCoinPayoutV2.Amount,
    }, 
    {
      index: 1,
      title:"Review",
      stepTitle: "Review the details of your transaction",
      description: null,
      component: StableCoinPayoutV2.Review,
    }
  ],
 
}

export const ghsPayoutMethods = [
  { label: "Bank account", value: "BANK_ACCOUNT" },
  { label: "Mobile money", value: "MOBILE_MONEY" },
];

export const GHS_PAYMENT_DESCRIPTION = [
  { value: "COMPUTER_SERVICES", label: "Computer services" },
  { value: "FAMILY_SUPPORT", label: "Family support" },
  { value: "EDUCATION", label: "Education" },
  { value: "GIFT_AND_DONATION", label: "Gift and donation" },
  { value: "MEDICAL_TREATMENT", label: "Medical treatment" },
  { value: "MAINTENANCE_EXPENSES", label: "Maintenance expenses" },
  { value: "TRAVEL", label: "Travel" },
  { value: "SMALL_VALUE_REMITTANCE", label: "Small value remittance" },
  { value: "LIBERALIZED_REMITTANCE", label: "Liberalized remittance" },
  { value: "CONSTRUCTION_EXPENSES", label: "Construction expenses" },
  { value: "HOTEL_ACCOMMODATION", label: "Hotel accommodation" },
  { value: "ADVERTISING_EXPENSES", label: "Advertising expenses" },
  { value: "ADVISORY_FEES", label: "Advisory fees" },
  { value: "BUSINESS_INSURANCE", label: "Business insurance" },
  { value: "INSURANCE_CLAIMS", label: "Insurance claims" },
  { value: "DELIVERY_FEES", label: "Delivery fees" },
  { value: "EXPORTED_GOODS", label: "Exported goods" },
  { value: "SERVICE_CHARGES", label: "Service charges" },
  { value: "LOAN_PAYMENT", label: "Loan payment" },
  { value: "OFFICE_EXPENSES", label: "Office expenses" },
  { value: "PROPERTY_PURCHASE", label: "Property purchase" },
  { value: "PROPERTY_RENTAL", label: "Property rental" },
  { value: "ROYALTY_FEES", label: "Royalty fees" },
  { value: "SHARES_INVESTMENT", label: "Shares investment" },
  { value: "FUND_INVESTMENT", label: "Fund investment" },
  { value: "TAX_PAYMENT", label: "Tax payment" },
  { value: "TRANSPORTATION_FEES", label: "Transportation fees" },
  { value: "UTILITY_BILLS", label: "Utility bills" },
  { value: "PERSONAL_TRANSFER", label: "Personal transfer" },
  { value: "SALARY_PAYMENT", label: "Salary payment" },
];

export const allowedPurposeMap: Record<string, string[]> = {
  C2C_BANK_CARD: [
    "FAMILY_SUPPORT",
    "TRAVEL",
    "INSURANCE",
    "SERVICE_CHARGES",
    "PATENT_ROYALTY",
    "OTHER",
  ],
  C2C_WALLET: [
    "SALARY",
    "FAMILY_SUPPORT",
    "TRAVEL",
    "INSURANCE",
    "INVESTMENT",
  ],
  B2C_BANK_ACCOUNT: [
    "SALARY",
    "FAMILY_SUPPORT",
    "TRAVEL",
    "INSURANCE",
    "SERVICE_CHARGES",
    "PATENT_ROYALTY",
    "OTHER",
  ],
  /*Todo add back when needed for B2B_BANK_ACCOUNT "GOODS_PURCHASE", */
  B2B_BANK_ACCOUNT: ["ECOMMERCE"],
  C2C_BANK_ACCOUNT: ["FAMILY_SUPPORT", "SALARY",
    "TRAVEL",
    "INSURANCE",
    "INVESTMENT",
    "SERVICE_CHARGES",
    "PATENT_ROYALTY",
    "OTHER"

  ],
}

export const senderTypeMap = {
  Yes: [{ label: "Business", value: "company" }],
  No: [
    { label: "Individual", value: "individual" },
    { label: "Business", value: "company" },
  ],
};

export const receiverTypeMap = {
  individual: [{ label: "Individual", value: "individual" }],
  company: [{ label: "Business", value: "company" }],
};

export const PAYMENT_METHODS = {
  unionpay: "unionpay",
  bank_account_individual: "bank_account_individual",
  bank_account_business: "bank_account_business",
  alipay: "alipay",
  wechatpay: "wechatpay",
};

export const paymentMethodMap = {
  company_individual: ["unionpay", "bank_account_individual"],
  company_company: ["bank_account_business"],
  individual_individual: ["unionpay", "alipay", "wechatpay", "bank_account_individual"],
  individual_company: ["unionpay", "bank_account_individual"],
};

export const getFilteredPaymentMethods = (
  senderType: string,
  receiverType: string,
  options?: { includeWeChat?: boolean },
) => {
  const key = `${senderType}_${receiverType}`;
  const allowed = paymentMethodMap[key] || [];

  return cnyTypeOfpaymentMethod.filter((method) => {
    if (!allowed.includes(method.value)) return false;
    if (options?.includeWeChat === false && method.value === "wechatpay") {
      return false;
    }
    return true;
  });
};

export const CNY_PRODUCT_CATEGORY = [
  { label: "Apparel", value: "APPAREL" },
  { label: "Beauty & Personal Care", value: "BEAUTY_PERSONAL_CARE" },
  { label: "Electronic Components", value: "ELEC_COMPONENTS" },
  { label: "Toys & Models", value: "TOYS MODELS" },
  { label: "Garden", value: "GARDEN" },
  { label: "Food", value: "FOOD" },
  { label: "Books & Media", value: "BOOKS_MEDIA" },
  { label: "Baby", value: "BABY" },
  { label: "Gifts & Crafts", value: "GIFTS_CRAFTS" },
  { label: "Auto Accessories", value: "AUTO_ACCESSORIES" },
  { label: "Home Goods", value: "HOME_GOODS" },
  { label: "Sports & Outdoors", value: "SPORTS OUTDOORS" },
  { label: "Jewelry", value: "JEWELRY" },
  { label: "Entertainment", value: "ENTERTAINMENT" },
  { label: "Musical Instruments", value: "MUSICAL INSTRUMENTS" },
  { label: "Electronics", value: "ELECTRONICS" },
  { label: "Antiques & Art", value: "ANTIQUES ART" },
  { label: "Watches & Eyewear", value: "WATCHES_EYEWEAR" },
  { label: "Mechanical Parts", value: "MECHANICAL_PARTS" },
];

export const stableCoinsList = [
  { label: "USDC", value: "USDC" },
  { label: "USDT", value: "USDT" },
]

export const stableCoinsArray = ["usdc", "usdt"]